import {Component, OnInit} from '@angular/core';
import {SalesReviewContractComponent} from '../sales-review-contract.component';
import {OtpServiceType} from '../../../../enums/otp-service-types.enum';

@Component({
  selector: 'app-sales-review-contract-v2',
  templateUrl: './sales-review-contract-v2.component.html'
})
export class SalesReviewContractV2Component extends SalesReviewContractComponent implements OnInit {
  override ngOnInit() {
    this.load();
    this.otpServiceType = this.request?.person?.otp_service ?? OtpServiceType.WHATSAPP;
    this.messageOtpServiceFirstSend = this.builtMsgSendFirstCode();
    this.sendCode(false, this.otpServiceType);
    setTimeout(() => {
      this.scrollEl = document.querySelector('#agreement-container') as HTMLDivElement;
    }, 0);
    this.showGetOtpOptions();
  }
}

@Component({
  selector: 'app-sales-review-contract-v3',
  templateUrl: './sales-review-contract-v3.component.html',
})
export class SalesReviewContractV3Component extends SalesReviewContractComponent implements OnInit {
  override ngOnInit() {
    this.load();
    this.otpServiceType = this.request?.person?.otp_service ?? OtpServiceType.WHATSAPP;
    this.messageOtpServiceFirstSend = this.builtMsgSendFirstCode();
    this.sendCode(false, this.otpServiceType);
    setTimeout(() => {
      this.scrollEl = document.querySelector('#agreement-container') as HTMLDivElement;
    }, 0);
    this.showGetOtpOptions();
  }
}
